import { useMediaQuery } from '@mui/material';
import { useDiagramContext } from '../Context/DiagramContext';

export const useDiagramLayout = () => {
  const {
    isExpanded,
    setIsExpanded,
    isProcessDiagram,
    selectedCard,
    selectedSubprocess,
    isDiagramChanged,
    activeModal,
    isEditPermission,
  } = useDiagramContext();

  const isMobile = useMediaQuery('(max-width:600px)');
  const isProcessXPLRActive = window.location.pathname.includes('process-xplr');

  const handleExpandToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const shouldShowSaveButtons = () => {
    if (isProcessDiagram) {
      return isDiagramChanged; // Always show Save/Discard for process diagrams; Save is separately disabled via isSaveDisabled
    }

    if (!selectedCard || !selectedSubprocess) return false;

    const processType = selectedCard.processType || selectedSubprocess.processType;
    const currentTab = activeModal;

    if (processType === 'custom' || isEditPermission) {
      if (currentTab === 'diagram') {
        return true;
      } else if (currentTab === 'processInfo') {
        return true;
      } else if (currentTab === null && activeModal === null) {
        return true;
      }
    }

    return false;
  };

  return {
    isExpanded,
    isMobile,
    isProcessXPLRActive,
    handleExpandToggle,
    shouldShowSaveButtons,
  };
};
